import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  Box,
  PopperPlacementType,
  IconButton,
  Tooltip,
} from "@mui/material";
import clsx from "clsx";

const PREFIX = "MoreOptionsMenu";

const classes = {
  icon: `${PREFIX}-icon`,
  overLap: `${PREFIX}-overLap`,
  border: `${PREFIX}-border`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.icon}`]: {
    "padding": ".25rem",
    "float": "right",
    "& svg": {
      color: theme.palette.primary.main,
    },
  },

  [`& .${classes.overLap}`]: {
    zIndex: 1,
  },

  [`& .${classes.border}`]: {
    border: `solid 1px ${theme.palette.primary.light}`,
    borderRadius: 5,
  },
}));

interface Props {
  id: string;
  popperPosition: PopperPlacementType;
  icon: React.ReactNode;
  toolTipText: string;
  children: React.ReactNode;
  close?: boolean;
}

export default function MoreOptionsMenu({
  id,
  popperPosition,
  toolTipText,
  children,
  icon,
  close,
}: Props) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen(!open);
  };
  React.useEffect(() => {
    if (close) {
      setOpen(false);
    }
  }, [close]);

  return (
    <Root>
      <Tooltip title={toolTipText} placement="top">
        <IconButton
          id={`menu-popup-button-${id}`}
          className={clsx(classes.icon, "more-options")}
          onClick={handleToggle}
          ref={anchorRef}
          aria-controls={open ? id : undefined}
          aria-haspopup="true"
          size="large"
        >
          {icon}
        </IconButton>
      </Tooltip>
      <Popper
        id="menu-popup-content"
        open={open}
        anchorEl={anchorRef.current}
        placement={popperPosition}
        transition
        disablePortal
        className={classes.overLap}
      >
        {({ TransitionProps }) =>
          open ? (
            <Grow {...TransitionProps}>
              <Paper className={classes.border}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <Box id={id}>{children}</Box>
                </ClickAwayListener>
              </Paper>
            </Grow>
          ) : undefined
        }
      </Popper>
    </Root>
  );
}
